/**
 * Hand-written types for the ToS offline-acceptance contract (ADR-0017 A6,
 * `wanderfit-api` PR #206). See CLAUDE.md → TD-07 for why the UI does not
 * import the generated surface.
 *
 * Two shapes exist on purpose. The admin user detail carries a SUMMARY of
 * every offline acceptance (readable by ADMIN and SUPPORT); the
 * permissioned list endpoint (`tos.offline.manage`, held only by
 * WANDERFIT_ADMIN) carries the full record with the admin-typed free text
 * and the actor ids. The UI renders `reference`, `note`, the actors and the
 * revocation reason ONLY from the full record, never from the summary.
 */

/** `GET /api/admin/users/:id` → `tosOfflineAcceptances[]` (live and revoked). */
export interface OfflineAcceptanceSummary {
  readonly id: string;
  readonly documentTypeId: string;
  readonly documentTypeKey: string;
  readonly recordedAt: string;
  /** Null while the acceptance is live. */
  readonly revokedAt: string | null;
}

/** `GET /api/admin/users/:id/tos/offline-acceptances` (and the POST / DELETE responses). */
export interface OfflineAcceptance extends OfflineAcceptanceSummary {
  readonly userId: string;
  readonly documentTypeName: string;
  /** Contract id or file name of the signed paper. */
  readonly reference: string;
  readonly note: string | null;
  /** The admin who recorded it. */
  readonly recordedByUserId: string;
  readonly revokedByUserId: string | null;
  readonly revokedReason: string | null;
}

export interface RecordOfflineAcceptanceInput {
  readonly documentTypeId: string;
  readonly reference: string;
  readonly note?: string;
}

export interface RevokeOfflineAcceptanceInput {
  readonly acceptanceId: string;
  readonly reason: string;
}

/** Mirrors the API DTO bounds (`offline-acceptance.dto.ts`). */
export const OFFLINE_REFERENCE_MAX = 300;
export const OFFLINE_NOTE_MAX = 1000;
export const OFFLINE_REASON_MAX = 1000;
